import { isArtistFollowed } from 'api/artists'
import { useAuth } from 'contexts'
import { useQuery } from 'react-query'

interface Config {
  id: number
}

export function useFollowedArtistQueryKey({ id }: Config) {
  return ['followed-artist', id]
}

export function useFollowedArtist({ id }: Config) {
  const qkey = useFollowedArtistQueryKey({ id })
  const { isAuthenticated } = useAuth()

  return useQuery(
    qkey,
    async () => {
      if (!id) return

      const { error, id: followArtistId } = await isArtistFollowed(id)

      if (error || !followArtistId) return

      return followArtistId
    },
    {
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      enabled: isAuthenticated,
    }
  )
}
